/* Saatchi Watch — variant chooser for Quick Add on cards with more than one variant.
   Single-variant cards add straight to the cart via sw.js; this only handles the rest. */
(() => {
'use strict';
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const CFG = window.SW || {}, R = CFG.routes || {};
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const root = () => { const r = R.root || '/'; return r.endsWith('/') ? r : r + '/'; };
const sized = (u, w) => { if (!u) return ''; if (u.startsWith('//')) u = 'https:' + u; return u + (u.includes('?') ? '&' : '?') + 'width=' + w; };
const money = c => { const n = Number(c) / 100, f = CFG.moneyFormat || '${{amount}}'; return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => { const cm = /comma_separator/.test(k), s = n.toFixed(/no_decimals/.test(k) ? 0 : 2).split('.'); s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, cm ? '.' : ','); return s.join(cm ? ',' : '.'); }); };
const say = m => { let r = $('#clLive'); if (!r) { r = document.createElement('div'); r.id = 'clLive'; r.className = 'sr'; r.setAttribute('aria-live', 'polite'); r.setAttribute('role', 'status'); document.body.appendChild(r); } r.textContent = ''; setTimeout(() => { r.textContent = m; }, 60); };

let box, opener, prod, chosen;
function build() {
  box = document.createElement('div');
  box.className = 'qv'; box.id = 'swVariantPick';
  box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true');
  box.setAttribute('aria-labelledby', 'vpTitle'); box.setAttribute('aria-hidden', 'true');
  box.innerHTML = `<button class="qv-close" type="button" data-vp-close aria-label="Close"><svg viewBox="0 0 24 24"><path d="m6 6 12 12M18 6 6 18"/></svg></button>
    <div class="qv-media"><div id="vpImg" style="width:100%;height:100%;display:grid;place-items:center"></div></div>
    <div class="qv-body" id="vpBody"></div>`;
  document.body.appendChild(box);
  box.addEventListener('click', e => { if (e.target.closest('[data-vp-close]')) close(); });
  box.addEventListener('keydown', e => {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    const f = $$('button:not(:disabled), a[href], input:not(:disabled)', box).filter(n => n.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  box.addEventListener('change', e => { if (e.target.name && e.target.name.startsWith('vp-opt')) pick(); });
  $('#scrim')?.addEventListener('click', close);
}
function close() {
  if (!box) return;
  box.classList.remove('on'); box.setAttribute('aria-hidden', 'true');
  if (!$$('.drawer.on, .qv.on').length) { $('#scrim')?.classList.remove('on'); document.body.style.overflow = ''; }
  opener?.focus();
}
function current() {
  const sel = $$('#vpBody [name^="vp-opt"]:checked').map(i => i.value);
  return prod.variants.find(v => v.options.every((o, i) => o === sel[i])) || null;
}
function pick() {
  chosen = current();
  const btn = $('#vpAdd'), price = $('#vpPrice'), img = $('#vpImg img');
  if (!chosen) { btn.disabled = true; btn.textContent = 'Unavailable'; say('That combination is unavailable'); return; }
  btn.disabled = !chosen.available;
  btn.textContent = chosen.available ? 'Add to cart' : 'Sold out';
  price.textContent = money(chosen.price);
  if (chosen.featured_image && img) { img.src = sized(chosen.featured_image.src, 900); img.alt = chosen.featured_image.alt || prod.title; }
  say(`${chosen.title}, ${money(chosen.price)}${chosen.available ? '' : ', sold out'}`);
}
async function open(handle, btn) {
  opener = btn;
  try { prod = await (await fetch(`${root()}products/${encodeURIComponent(handle)}.js`)).json(); } catch (e) { location.href = `${root()}products/${handle}`; return; }
  if (!box) build();
  const i = prod.title.indexOf(' | ');
  const name = i > -1 ? prod.title.slice(i + 3) : prod.title, model = i > -1 ? prod.title.slice(0, i) : '';
  const first = prod.variants.find(v => v.available) || prod.variants[0];
  $('#vpImg').innerHTML = prod.featured_image ? `<img src="${esc(sized(prod.featured_image, 900))}" alt="${esc(prod.title)}">` : '';
  $('#vpBody').innerHTML = `
    ${model ? `<p class="mono" style="color:var(--muted)">${esc(model)}</p>` : ''}
    <h2 class="h-s" id="vpTitle">${esc(name)}</h2>
    <div class="p-price"><span class="now" id="vpPrice">${money(first.price)}</span></div>
    <div class="p-opts">${prod.options.map((o, oi) => `
      <fieldset class="p-opt"><legend>${esc(o.name)}</legend><div class="p-vals">
        ${o.values.map((val, vi) => `<label class="p-v"><input type="radio" name="vp-opt${oi}" value="${esc(val)}"${first.options[oi] === val ? ' checked' : ''}><span>${esc(val)}</span></label>`).join('')}
      </div></fieldset>`).join('')}</div>
    <div class="s-cta">
      <button class="btn btn-solid" type="button" id="vpAdd" style="flex:1"></button>
      <a class="btn btn-ghost" href="${esc(prod.url || root() + 'products/' + prod.handle)}"><span>Full details</span></a>
    </div>
    <p class="p-err" id="vpErr" role="alert"></p>`;
  pick();
  $('#vpAdd').addEventListener('click', add);
  box.classList.add('on'); box.setAttribute('aria-hidden', 'false');
  $('#scrim')?.classList.add('on'); document.body.style.overflow = 'hidden';
  setTimeout(() => $('#vpBody input:checked')?.focus(), 80);
}
async function add() {
  if (!chosen || !chosen.available) return;
  const btn = $('#vpAdd'), err = $('#vpErr');
  btn.disabled = true; const label = btn.textContent; btn.textContent = 'Adding…'; err.textContent = '';
  try {
    const r = await fetch((R.add || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: chosen.id, quantity: 1 }] }) });
    const d = await r.json();
    if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart');
    say(`${prod.title} added to your cart`);
    close();
    const c = $('#btnCart'); if (c) setTimeout(() => c.click(), 260);
  } catch (e) { err.textContent = e.message; say(e.message); btn.textContent = label; btn.disabled = false; }
}
document.addEventListener('click', e => {
  const b = e.target.closest('[data-qv-options]');
  if (!b) return;
  e.preventDefault(); e.stopPropagation();
  open(b.dataset.qvOptions, b);
}, true);
})();